import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PremiumLockProps {
    title: string;
    description: string;
}

const PremiumLock: React.FC<PremiumLockProps> = ({ title, description }) => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px 20px',
            background: 'var(--bg-box)',
            borderRadius: '20px',
            border: '1px dashed var(--border-color)',
            textAlign: 'center',
            margin: '20px 0'
        }}>
            <div style={{
                fontSize: '4rem',
                marginBottom: '20px',
                animation: 'bounce 2s infinite'
            }}>
                🔒
            </div>

            <h2 style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                color: 'var(--text-heading)',
                marginBottom: '10px'
            }}>
                {title}
            </h2>

            <p style={{
                fontSize: '1.1rem',
                color: 'var(--text-muted)',
                maxWidth: '500px',
                marginBottom: '30px',
                lineHeight: '1.6'
            }}>
                {description}
            </p>

            <button
                onClick={() => navigate('/upgrade')}
                style={{
                    padding: '12px 30px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                    transition: 'transform 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                Débloquer maintenant
            </button>

            <style>
                {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
            40% {transform: translateY(-10px);}
            60% {transform: translateY(-5px);}
          }
        `}
            </style>
        </div>
    );
};

export default PremiumLock;
